import { Pipe, PipeTransform } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';

export class UnitFormat {
  unitSign: string;
}

@Pipe({
  name: 'qPointNumberFormat',
  standalone: true,
  pure: false
})
export class QPointNumberFormatPipe implements PipeTransform {

  private unitFormatMap = new Map<string, string>([
    ["t", ",0.00"],
    ["m³", ",0.00"]
  ])

  constructor(private intlService: IntlService) {
  }

  transform(value?: number, customFormat?: string | number | UnitFormat): string {
    if (value === null) {
      return null;
    }
    if (customFormat) {
      if (typeof customFormat === 'string') {
        return this.intlService.formatNumber(value, customFormat);
      }
      if (Number.isInteger(customFormat) && (customFormat as number) >= 0) {
        const numberFormat = `n${customFormat}`;

        return this.intlService.formatNumber(value, numberFormat);
      }
      if (typeof customFormat === "object") {
        let format = "";
        if(customFormat.unitSign) {
          format = this.unitFormatMap.get(customFormat.unitSign) ?? ",0";
        } else {
          format = ",0.00"
        }
        return this.intlService.formatNumber(value, format);
      }
    }
    return this.intlService.formatNumber(value, 'n0');
  }

}
